<template>
  <button type="button" class="mbtn btn-danger">
    <i class="fa-solid fa-circle-xmark"></i>
    {{ caption }}
  </button>
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: "Cancel",
    },
  },
};
</script>
